import { Injectable, Inject } from '@angular/core';
import { Product } from './product';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams , HttpErrorResponse, HttpResponse} from '@angular/common/http';
// import { WindowService } from '../window.service';

import { WindowRefService, ICustomWindow } from '../window-ref.service';
import { ResponseContentType } from '@angular/http';
import { environment } from '../../environments/environment';
// import { ConfigurationService } from '../configuration.service';
import { Configuration } from '../configuration';


@Injectable()
export class FileDownloadService {
  private apiUrl: string  = '/api';
  private imageBase: string = '';
  private _window: ICustomWindow;

  constructor(
    windowRef: WindowRefService,
    private http: HttpClient
    // private configurationService: ConfigurationService
  ) {
    this.apiUrl = `${environment.serverUrl}/api`;
    this.imageBase = `${environment.imageBase}`;
    this._window = windowRef.nativeWindow;
  }


  private serialize (obj, prefix) {
    var str = [],
      p;
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + "[" + p + "]" : p,
          v = obj[p];
        str.push((v !== null && typeof v === "object") ?
          this.serialize(v, k) :
          encodeURIComponent(k) + "=" + encodeURIComponent(v));
      }
    }
    return str.join("&");
  }

  fetchProduct(file: Product, config: Configuration): Observable<Boolean> {



    // var dlurl = 'download-file.php?name='+p[3];
    // 	dlurl += '&cost='+p[0];
    // 	dlurl += '&cat='+p[1];
    // 	dlurl += '&type='+p[2];
    // 	dlurl += '&key='+$('#frmSULicenseKey').val();
  const fileRequest: any = {
    name:file.title,
    cat: file.category[0].id,
    type:file.type
  }

  const params = `0|${file.category[0].id}|${file.type}`;
  const su_root: string = file.filename.split('/')[1] || '';


  const regex= new RegExp('sa=1' , 'i');
  const downloadUrlTest = regex.test(file.filename);


  const dlurl:string = `download-file.php${this.serialize(fileRequest,'')}`;
/**
 *  /download/
 *      zzzzzzzzzz/xxxxxxxxxx/yyyyyyyyyy
 *			Where zzzzzzzzzz is the hash value for the file from the JSON data
 *			Where xxxxxxxxxx is the javascript license variable value
 *			Where yyyyyyyyyy is the mac_address variable value
 */
  const obs = Observable.create((observer: any) => {

    try {

      if (downloadUrlTest || config.standalone) {
        this._window.location.href = `/download/${file.hash}/${config.license}/${config.mac_address}`;
      } else {

        if (su_root == "textures" ) {
          console.log('load texture into sketchup');
          this._window.location.href = `skp:on_texture@${file.hash}|${file.category[0].category_name}|${file.title}`;
        } else {
          console.log('load file into sketchup');
          console.log('`skp:on_load_comp@${file.hash}|${file.category[0].category_name}|${file.title}`');
          this._window.location.href = `skp:on_load_comp@${file.hash}|${file.category[0].category_name}|${file.title}`
        }
      }

      observer.next(true);
      observer.complete();

    }
    catch (e) {
      observer.error(e);
    }

  });

  return obs;


}


  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();

    const obs = Observable.create((observer: any) => {
      reader.onloadend = (e) => {
        observer.error(JSON.parse(reader.result));
        observer.complete();
      }
    });
    reader.readAsText(err.error);
    return obs;
}

}



// WEBPACK FOOTER //
// ./src/app/products/file-download.service.ts